module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/0113ff98f5b42f42a53702f1e8db9499.png";